import React from 'react'
import CloseVirtualCard from 'src/app/CloseVirtualCard/CloseVirtualCard'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { closeVirtualCardRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const CloseVirtualCardAppRoute: AppRoute = {
  id: AppLocation.CloseVirtualCard,
  routeProps: closeVirtualCardRouteProps,
  component: <CloseVirtualCard />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default CloseVirtualCardAppRoute
